import React from 'react';
import { Package, TruckIcon, CheckCircle, XCircle, Clock, MapPin } from 'lucide-react';

function StatisticsCards({ deliveries, orders }) {
  function getStatusCounts() {
    const counts = {
      total: deliveries.length,
      pending: 0,
      encamino: 0,
      entregado: 0,
      cancelado: 0,
      rechazado: 0,
    };

    deliveries.forEach(delivery => {
      if (counts.hasOwnProperty(delivery.status)) {
        counts[delivery.status]++;
      }
    });

    return counts;
  }

  const stats = getStatusCounts();
  const totalOrders = orders.length;

  const cards = [
    {
      title: 'Total Entregas',
      value: stats.total,
      icon: Package,
      color: 'from-[#B1336E] to-[#E6B43C]',
      textColor: 'text-[#B1336E]',
    },
    {
      title: 'Pendientes',
      value: stats.pending,
      icon: Clock,
      color: 'from-orange-400 to-orange-500',
      textColor: 'text-orange-600',
    },
    {
      title: 'En Camino',
      value: stats.encamino,
      icon: TruckIcon,
      color: 'from-blue-400 to-blue-500',
      textColor: 'text-blue-600',
    },
    {
      title: 'Entregados',
      value: stats.entregado,
      icon: CheckCircle,
      color: 'from-[#67A43C] to-green-500',
      textColor: 'text-[#67A43C]',
    },
    {
      title: 'Cancelados',
      value: stats.cancelado,
      icon: XCircle,
      color: 'from-red-400 to-red-500',
      textColor: 'text-red-600',
    },
    {
      title: 'Rechazados',
      value: stats.rechazado,
      icon: XCircle,
      color: 'from-red-500 to-red-600',
      textColor: 'text-red-700',
    },
  ];

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-sm border border-slate-200 p-4 hover:shadow-md transition-shadow"
          >
            <div className={`w-12 h-12 rounded-xl bg-gradient-to-br ${card.color} flex items-center justify-center mb-3`}>
              <Icon className="w-6 h-6 text-white" />
            </div>
            <p className="text-2xl font-extrabold font-montserrat mb-1" style={{ color: card.textColor.replace('text-', '') }}>
              {card.value}
            </p>
            <p className="text-xs text-slate-600 font-montserrat">
              {card.title}
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default StatisticsCards;